import { type HTMLAttributes } from 'react'
import styles from './StatusBadge.module.css'

type StatusBadgeTone = 'default' | 'ready' | 'failed'

type StatusBadgeProps = HTMLAttributes<HTMLSpanElement> & {
  label: string
  tone?: StatusBadgeTone
}

const getStatusTone = (label: string): StatusBadgeTone => {
  if (label === 'ready' || label === 'reachable' || label === 'active') {
    return 'ready'
  }

  if (label === 'failed' || label === 'error') {
    return 'failed'
  }

  return 'default'
}

export const StatusBadge = ({
  className,
  label,
  tone = getStatusTone(label),
  ...props
}: StatusBadgeProps) => (
  <span className={[styles.badge, styles[tone], className].filter(Boolean).join(' ')} {...props}>
    {label}
  </span>
)
